/** @format */

import { Injectable, Renderer2, RendererFactory2, DOCUMENT, inject } from '@angular/core';

/**
 * Service to use styles with directives
 * @dynamic
 */
@Injectable({
  providedIn: 'root',
})
export class DirectiveStylesService {
  private readonly renderer: Renderer2;
  private readonly documentRef = inject(DOCUMENT);

  constructor() {
    const rendererFactory = inject(RendererFactory2);
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  addStyle(styles: string, attribute: string) {
    if (this.documentRef.head.querySelector(`style[${attribute}]`)) {
      return;
    }

    const style = this.renderer.createElement('style');

    this.renderer.setProperty(style, 'textContent', styles);
    this.renderer.setAttribute(style, attribute, '');

    this.documentRef.head.appendChild(style);
  }
}
